export default "__VITE_ASSET__B_B$_as4__"